export default __webpack_public_path__ + "static/media/Avatar-6-noback.ce8d54e0.png";